// extracted by mini-css-extract-plugin
module.exports = {"col3":"Card_col3__3i6_x","cardDesc":"Card_cardDesc__1swns","img":"Card_img__1Vjf3"};